// import Promise from 'pinkie-promise';
import platformApi from '@/api/platformApi.js';
import { PLATFORM_TYPE } from '@/utils/uploadImg.js';
import gaodeMap from '@/utils/maps/gaodeMap';
import BrowserCallNative from './BrowserCallNative.js';
import wechat from '../platformUtils/wechat';
import env from '../env.js';
import WalletService from '../../service/walletService';
import VipService from '../../service/vipService';
import getSearchObj from '../getSearchObj';

const MSG_CALLBACKS = {};

function callWeixinWindow(name, data, callback) {
  const dataStr = JSON.stringify(data);
  const key = name + Math.floor(Math.random() * 10000);
  const message = JSON.stringify({
    key,
    name,
    data: dataStr,
  });
  MSG_CALLBACKS[key] = callback;
  window.top.postMessage(message, '*');
}

class WeixinCallNative extends BrowserCallNative {
  static setPageTitle({ title }) {
    if (env.isIOS && title !== undefined) {
      return new Promise((resolve, reject) => {
        try {
          document.title = title;
          const iframe = document.createElement('iframe');
          iframe.style.visibility = 'hidden';
          iframe.style.width = '1px';
          iframe.style.height = '1px';
          iframe.onload = () => {
            window.setTimeout(() => {
              document.body.removeChild(iframe);
              resolve(true);
            }, 0);
          };
          document.body.appendChild(iframe);
          // iframe.src = require('!!url?limit=1!./wechart-title.png');  // 这个文件仅作为workaround
        } catch (e) {
          reject(new Error(e));
        }
      });
    }
    return super.setPageTitle({ title });
  }

  static scanQRCode() {
    return wechat.scanQRCode();
  }

  static chargeWallet(options) {
    return WalletService.chargeWalletWechat(options).then((data) => {
      const backUrl = window.location.href.replace(window.location.hash, '#/wallet/charge-success');
      const params = [
        `timestamp=${encodeURIComponent(data.timeStamp)}`,
        `nonceStr=${encodeURIComponent(data.nonceStr)}`,
        `package=${encodeURIComponent(data.package)}`,
        `paySign=${encodeURIComponent(data.paySign)}`,
        `successUrl=${encodeURIComponent(backUrl)}`,
      ].join('&');
      window.location.href = `./wechat-payment.html?${params}`;
    });
  }

  static chargeDeposit(options) {
    return WalletService.chargeDepositWechat(options).then((data) => {
      const backUrl = `${window.location.href}${/#.+\?/.test(window.location.href) ? '&' : '?'}check=true`;
      const params = [
        `timestamp=${encodeURIComponent(data.timeStamp)}`,
        `nonceStr=${encodeURIComponent(data.nonceStr)}`,
        `package=${encodeURIComponent(data.package)}`,
        `paySign=${encodeURIComponent(data.paySign)}`,
        `successUrl=${encodeURIComponent(backUrl)}`,
      ].join('&');
      window.location.href = `./wechat-payment.html?${params}`;
    });
  }

  static chargeVip(options) {
    return VipService.chargeVipWechat(options).then((data) => {
      const backUrl = window.location.href.replace(window.location.hash, '#/wallet/charge-success?payType=vip');
      const params = [
        `timestamp=${encodeURIComponent(data.timeStamp)}`,
        `nonceStr=${encodeURIComponent(data.nonceStr)}`,
        `package=${encodeURIComponent(data.package)}`,
        `paySign=${encodeURIComponent(data.paySign)}`,
        `successUrl=${encodeURIComponent(backUrl)}`,
      ].join('&');
      window.location.href = `./wechat-payment.html?${params}`;
    });
  }

  static async getTokenAndKey() {
    return getSearchObj() || {};
  }

  static callNative(name, data) {
    if (window !== window.top) {
      return new Promise((resolve) => {
        if (window !== window.top) {
          callWeixinWindow(name, data, (responseData) => {
            // TODO 处理异常情况
            resolve(responseData);
          });
        }
      });
    }

    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在微信中暂时无法使用`));
    }
    return this[name](data);
  }

  /**
   * 页面跳转
   * @param {string} url跳转链接
   */
  static navigateTo(url) {
    return wechat.navigateTo(url);
  }

  static redirectTo(url) {
    return wechat.redirectTo(url);
  }

  static closeWebView() {
    return wechat.closeWindow();
  }

  static callphotograph(onlyUseCamera) {
    return new Promise((reslove, reject) => {
      wechat.config().then((wx) => {
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original', 'compressed'],
          sourceType: onlyUseCamera ? ['camera'] : ['album', 'camera'],
          success: (res) => {
            const localId = res.localIds[0];
            wx.getLocalImgData({
              localId,
              success(data) {
                // alert("getSuccess");
                const base64SplitArray = data.localData.split(',');
                // 微信 sdk 转换出来的 base64 格式是 jgp，此处做个兼容
                // base64SplitArray[0] = base64SplitArray[0].replace("image/jgp", "image/jpeg");
                // let base64String = base64SplitArray.join(",");
                // console.log('==>base64', base64SplitArray[1]);
                let relFile = '';
                if (env.isIOS) {
                  relFile = base64SplitArray[1] || data.localData;
                } else if (env.isAndroid) {
                  relFile = data.localData;
                }

                if (!relFile) {
                  // TIANQI_UBT.customEvent({
                  //   eventId: 'wechat_callphotograph_error',
                  //   categoryId: 'hitch',
                  // }); TODO
                }

                reslove(relFile);
              },
              fail() {
                reject();
              },
            });
          },
          cancel() {
            // reject();
          },
          fail() {
            reject(new Error('照片选择失败'));
          },
        });
      }).catch((e) => reject(e));
    });
  }

  static async chooseImageAndUploadImage(Params) {
    let beforeUpload;
    let afterUpload;
    if (Params) {
      ({
        beforeUpload,
        afterUpload,
      } = Params);
    }
    const onlyUseCamera = !!(Params && Params.onlyUseCamera);
    const relFile = await this.callphotograph(onlyUseCamera);
    if (beforeUpload) {
      beforeUpload();
    }
    try {
      const imageUrl = await platformApi.uploadImage({
        file: relFile || '',
        image: 40,
        type: PLATFORM_TYPE.WX_MP,
      });
      if (afterUpload) {
        afterUpload();
      }
      return imageUrl.url;
    } catch (error) {
      if (afterUpload) {
        afterUpload();
      }
      return '';
    }
  }

  static async getCityInfoV2() {
    const defaultCityInfo = {
      citycode: '',
      adcode: '',
      city: '',
      latitude: '',
      longitude: '',
    };

    try {
      const { latitude, longitude } = await this.getLocation();

      if (!latitude || !longitude) {
        return defaultCityInfo;
      }

      const location = await gaodeMap.geoDecode(longitude, latitude);

      return {
        citycode: location.citycode || '',
        adcode: location.adcode || '',
        city: location.cityName || '',
        latitude,
        longitude,
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching city info:', error); // 更详细的错误日志
      return defaultCityInfo;
    }
  }

  static getLocation() {
    return new Promise((resolve, reject) => {
      try {
        const res = wechat.getLocation();
        // eslint-disable-next-line no-console
        resolve(res);
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default WeixinCallNative;

if (env.isWeixin && window !== window.top) {
  window.addEventListener('message', (e) => {
    let message = e.data;
    if (typeof message === 'string') {
      message = JSON.parse(e.data);
    }

    if (message.key) {
      if (typeof MSG_CALLBACKS[message.key] === 'function') {
        MSG_CALLBACKS[message.key](JSON.parse(message.data));
        delete MSG_CALLBACKS[message.key];
      }

      if (message.name === 'goBack' && message.data !== 'true') {
        if (window.history.state) {
          window.history.back();
        } else if (parseInt(message.data, 10)) {
          WeixinCallNative.callNative('popHistory', null)
            .then(() => {
              window.history.back();
            });
        } else {
          WeixinCallNative.callNative('goBack', null);
        }
      }
    }
  });
}
